export default {
  ATTACHMENT: 'edit-modal-attachment',
  LINK: 'portal-link',
  SEARCH_PIN: 'search-pin-row',
  TILE: 'portal-tile',
};
